import Loader from '../../../Utility/Loader/Loader';
import './NewDrawerButton.css';

export type NewDrawerButtonVariant = 'save' | 'discard' | 'close';

export interface NewDrawerButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  variant: NewDrawerButtonVariant;
  loading?: boolean;
}

const VARIANT_CLASS: Record<NewDrawerButtonVariant, string> = {
  save: 'new-drawer-btn--save',
  discard: 'new-drawer-btn--discard',
  close: 'new-drawer-btn--close',
};

/**
 * NewDrawerButton — Save / Discard / Close action button for drawer headers
 * per Figma spec §4.1. No icon on Save.
 */
function NewDrawerButton({
  variant,
  loading = false,
  disabled,
  children,
  className,
  ...rest
}: NewDrawerButtonProps) {
  const rootClass = ['new-drawer-btn', VARIANT_CLASS[variant], className].filter(Boolean).join(' ');
  return (
    <button type="button" className={rootClass} disabled={disabled || loading} {...rest}>
      {loading ? (
        <span className="new-drawer-btn__spinner">
          <Loader />
        </span>
      ) : null}
      <span>{children}</span>
    </button>
  );
}

export default NewDrawerButton;
